/**
 * "Prepared By" is the salesperson named on the quotation. Proforma and tax-invoice documents are
 * written later by whoever pressed Generate, so the chain's quotation always wins over the row's
 * own creator — a sync run by Accounts must not relabel the document as theirs.
 */
export function preparedByOf(row: any, sourceQuotation?: any): string {
  const quot = sourceQuotation ?? row?._quotDoc;
  const proforma = row?._proformaDoc;
  return String(
    quot?.preparedBy ||
      proforma?.preparedBy ||
      row?.preparedBy ||
      quot?.requestedByName ||
      proforma?.requestedByName ||
      ''
  ).trim();
}
